<template>
  <div>
    <Back :backText="$t('mark_back')" :definition="true" @goBackRoute="onClickBack"></Back>
    <div class="chart-content report_box">
      <div class="report_title">{{ $t('Level_test') }}</div>
      <div class="report_date_box">
        <span class="report_date_num"
          >{{ $t('On') }} {{ userArr.grading_at }} {{ $t('working_towards') }}</span
        >
        <span class="report_date_level">&ensp;{{ userArr.next_level_name }}</span>
      </div>
      <div class="chart_total_box">
        <!-- 隐藏雷达图 -->
        <!-- <div id="chartBarNav" class="chart-bar"></div> -->
        <div class="chart-message">
          <!-- <div class="chart-message-title">
            <p>{{ $t("spc_result_tips", { level: finaleLevel }) }}</p>
            <p>{{ $t("spc_recommend_test", { level: recommendLevel || 1 }) }}</p>
          </div> -->
          <div class="chart-text">
            <div v-for="(item, index) in currentDescList" :key="index" class="chart_text_box">
              <span :class="[expanWidth ? 'expan-width' : '', 'chart_title']">{{
                item.title
              }}</span>
              <div class="chart_intro">{{ item.intro }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_box">
        <div class="level_btn" @click="startSpc">{{ $t('Retake_level_test') }}</div>
        <div class="practice_btn" @click="goPractice">{{ $t('practice_test') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { JsonData } from '@/utils/spcTool.js'
import { mapState, mapGetters } from 'vuex'
import echarts from 'echarts'
import { GradeAbilities } from '@/model/globalData'
import Back from '@/components/common/Back'
import analytics from '@/utils/AnalyticsCenter'
export default {
  components: {
    Back,
  },
  data() {
    return {
      chartBarData: [],
      userArr: '',
    }
  },
  computed: {
    ...mapState({
      // 水平测试信息
      finaleLevel: (state) => state.grade.finaleLevel,
      recommendLevel: (state) => state.grade.recommendLevel,
      levelActiveIndex: (state) => state.level.levelActiveIndex,
      levelList: (state) => state.level.levelList,
    }),
    abilityAssess() {
      return this.$store.state.grade.abilityAssess
    },
    currentDescList() {
      return (
        JsonData?.[`content_${localStorage.getItem('language')}`]?.[`level${this.finaleLevel}`] ||
        []
      )
    },
    // 英语和越南语设置单独样式
    expanWidth() {
      const currentLanguage = localStorage.getItem('language')
      if (
        currentLanguage === 'en' ||
        currentLanguage === 'vi' ||
        currentLanguage === 'fr' ||
        currentLanguage === 'th'
      ) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    abilityAssess() {
      this.chartBarData = GradeAbilities.map((item) => this.abilityAssess[item])
    },
  },
  mounted() {
    this.chartBarData = GradeAbilities.map((item) => this.abilityAssess[item])
    // this.renderChart()
    this.getGradingAt()
  },
  methods: {
    getLevelTypeNameByRoute() {
      let path = window.location.pathname || this.$route.path
      return path.split('/')[1]
    },
    goPractice() {
      analytics.logEvent('hskweb_leveltesttomock_click', { level: this.userArr.level_name })
      let next_level_type = '1'
      const { next_level_id, next_level } = this.userArr
      let nextObj = this.levelList.find((item) => {
        let flag = item.levels.some((level) => {
          if (level.id == next_level_id) {
            return true
          }
        })
        if (flag) {
          return item
        }
      })
      next_level_type = nextObj.level_type
      let levelTypeName = this.getLevelTypeNameByRoute()
      this.$store
        .dispatch('level/changeLevel', {
          levelType: next_level_type,
          levelId: next_level_id,
          levelIndex: next_level,
        })
        .then(() => {
          this.$router.push({
            path: `/${levelTypeName || 'hsk'}/tests`,
            query: {
              level: `${levelTypeName}${next_level}`,
            },
          })
        })
    },
    startSpc() {
      analytics.logEvent('hskweb_leveltestretake_click', { level: this.userArr.level_name })
      this.$router.push({
        name: 'spcExamination',
      })
    },
    getGradingAt() {
      utilV2.getData(ApiPath.get_spc_usermessage, {}, (data) => {
        this.userArr = data
        // 访问水平测试页面
        analytics.logEvent('hskweb_leveltestreport_view', { level: this.userArr.level_name })
      })
    },
    // 点击返回
    onClickBack() {
      analytics.logEvent('hskweb_leveltestreportback_click', { level: this.userArr.level_name })
      this.$router.go(-1)
    },
    renderChart() {
      let chartBar = echarts.init(document.getElementById('chartBarNav'))
      let option = {
        color: ['#FAAE56'],
        radar: {
          indicator: [
            { name: this.$t('spc_listen'), max: 100 },
            { name: this.$t('spc_speak'), max: 100 },
            { name: this.$t('spc_read'), max: 100 },
            { name: this.$t('spc_write'), max: 100 },
            { name: this.$t('spc_translation'), max: 100 },
          ],
          name: {
            textStyle: {
              padding: [-10, -10],
            },
          },
          axisLine: {
            lineStyle: {
              color: '#545F6B',
              width: 0,
            },
          },
          splitLine: {
            lineStyle: {
              color: '#C5D2E1',
            },
          },
          splitArea: {
            areaStyle: {
              color: [],
            },
          },
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            data: [
              {
                value: this.chartBarData,
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: '#FAAE56',
                      offset: 0,
                    },
                    {
                      color: '#FAAE56',
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      }
      chartBar.resize()
      chartBar.setOption(option)
    },
  },
}
</script>
<style scoped lang="scss">
.report_box {
  width: 1200px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.report_title {
  color: #2c2f46;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  margin-top: 36px;
}

.report_date_box {
  margin-top: 14px;
  margin-bottom: 37px;

  .report_date_num {
    color: #2c2f46;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    line-height: 18px;
  }

  .report_date_level {
    color: #faae56;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }
}

.btn_box {
  display: flex;
  margin-top: 65px;
  margin-bottom: 65px;
  .level_btn {
    width: 254px;
    padding: 0px 24px;
    border-radius: 4px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border: 0.5px solid var(--Wohui-Grey-3, #b5b5be);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%), #fff;
    margin-right: 31px;
    cursor: pointer;
  }

  .practice_btn {
    width: 254px;
    padding: 0px 24px;
    border-radius: 4px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background: #faae56;
    color: white;
    cursor: pointer;
  }
}
.chart_text_box {
  display: flex;
  .chart_title {
    color: var(--Wohui-Sunshine, #faae56);
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    /* 171.429% */
    margin-right: 26px;
    &.expan-width {
      width: 100px;
    }
  }

  .chart_intro {
    color: var(--Wohui-Grey-2, #696974);
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    width: 389px;
    /* 171.429% */
  }
}
.chart-bar {
  height: 254px;
  width: 340px;
  margin-right: 19px;
}
.chart_total_box {
  display: flex;
  align-items: center;
}
</style>
